export default __webpack_public_path__ + "static/media/ico_checkbox_disabled.41cb5e3a.svg";